module.exports = __webpack_public_path__ + "static/media/Add_to_Google_Wallet.b7de6257.svg";